import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export default function OnboardingPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);

  const steps = [
    { title: 'Welcome to Profit Pulse', desc: 'Your institutional-grade copy trading platform. Let\'s get you set up in 5 easy steps.', icon: '🚀' },
    { title: 'Choose Your Broker', desc: 'Connect your trading account to start automatic copy trading. We support TradeLocker, MetaTrader, Tradovate, and more.', icon: '🏦', action: () => navigate('/link-broker') },
    { title: 'Select Your Strategies', desc: 'Browse our expert trading strategies and choose which ones to copy. Each strategy has detailed performance metrics.', icon: '📊', action: () => navigate('/strategies') },
    { title: 'Set Your Risk Level', desc: 'Configure your lot size, risk multiplier, and daily loss limits. We recommend starting at 1x (standard) risk.', icon: '⚖️' },
    { title: 'You\'re All Set!', desc: 'Your account is configured and ready. Our algorithms will automatically copy trades from institutional-grade strategies to your account.', icon: '✅' },
  ];

  const current = steps[step];

  return (
    <div style={{ minHeight: '100vh', background: 'var(--pp-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px' }}>
      <div style={{ maxWidth: 420, width: '100%' }}>
        {/* Progress */}
        <div style={{ display: 'flex', gap: 6, marginBottom: 40 }}>
          {steps.map((_, i) => (
            <div key={i} style={{ flex: 1, height: 3, background: i <= step ? 'var(--pp-primary)' : 'var(--pp-border)', transition: 'background 300ms' }} />
          ))}
        </div>

        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ fontSize: 64, marginBottom: 20 }}>{current.icon}</div>
          <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 12 }}>{current.title}</h2>
          <p style={{ fontSize: 15, color: 'var(--pp-text-2)', lineHeight: 1.7 }}>{current.desc}</p>
        </div>

        {current.action && step < steps.length - 1 && (
          <button onClick={current.action} style={{ width: '100%', height: 52, background: 'var(--pp-surface)', border: '1px solid var(--pp-border)', color: 'var(--pp-text)', fontSize: 14, fontWeight: 600, cursor: 'pointer', marginBottom: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
            Go to {current.title.split(' ').slice(-1)[0]} <ChevronRight size={16} />
          </button>
        )}

        {step < steps.length - 1 ? (
          <button onClick={() => setStep(step + 1)} className="btn-primary" style={{ width: '100%', height: 52 }}>Continue →</button>
        ) : (
          <button onClick={() => navigate('/dashboard')} className="btn-primary" style={{ width: '100%', height: 52 }}>Start Trading</button>
        )}

        {step > 0 && (
          <button onClick={() => setStep(step - 1)} style={{ width: '100%', height: 40, background: 'none', border: 'none', color: 'var(--pp-text-3)', fontSize: 13, cursor: 'pointer', marginTop: 12 }}>← Back</button>
        )}
      </div>
    </div>
  );
}
